"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EdAccessFormFields = exports.DashboardRestrictionPolicies = void 0;
var DashboardRestrictionPolicies;
exports.DashboardRestrictionPolicies = DashboardRestrictionPolicies;

(function (DashboardRestrictionPolicies) {
  DashboardRestrictionPolicies["All"] = "all";
  DashboardRestrictionPolicies["Admins"] = "admins";
})(DashboardRestrictionPolicies || (exports.DashboardRestrictionPolicies = DashboardRestrictionPolicies = {}));

var EdAccessFormFields;
exports.EdAccessFormFields = EdAccessFormFields;

(function (EdAccessFormFields) {
  EdAccessFormFields["RestrictionPolicy"] = "restrictionPolicy";
})(EdAccessFormFields || (exports.EdAccessFormFields = EdAccessFormFields = {}));